module.exports = __webpack_public_path__ + "img/devlet-destekli-alacak-sigortasi.586bb6d8.png";